<template>
	<mdb-col v-bind="colBind" class="bg-white text-dark">
		<data-table :data="{ columns, rows }" :pagination="pagination" :search="search" :current-page="currentPage"
					@page="changePage" :header-color="headerColor" :header-white="headerWhite" nulls-last refresh arrows striped bordered class="align-self-center w-100" v-on="on">
			<template v-slot:pre-fieldset>
				<slot name="pre-fieldset"></slot>
			</template>
			<template v-slot:pre-th>
				<slot name="pre-th"></slot>
			</template>
			<template v-slot:post-th>
				<slot name="post-th">
					<th></th>
				</slot>
			</template>
			<template v-slot:pre-th-foot>
				<slot name="pre-th-foot"></slot>
			</template>
			<template v-slot:post-th-foot>
				<th></th>
			</template>
			<template v-slot:pre-td="{ row }">
				<slot name="pre-td" :row="row"></slot>
			</template>
			<template v-for="column in columns" v-slot:[`_`+column.field]="{ field, row, index, value }">
				<div v-if="column.readonly" :key="column.field">
					<slot :name="'__' + field" :field="field" :row="row" :index="index" :value="value">
						<div v-html="value"></div>
					</slot>
				</div>
				<div v-else :key="column.field">
					<slot :name="'__' + field" :field="field" :row="row" :index="index" :value="value">
						<input class="w-100" :value="value" @change="change({ field, row, index, value: $event })"/>
					</slot>
				</div>
			</template>
			<template v-slot:post-td="{ row }">
				<td>
					<mdb-btn @click="remove(row)" color="danger" size="sm" rounded>Remove</mdb-btn>
				</td>
			</template>
			<template v-slot:last-row>
				<tr>
					<slot name="pre-td" :row="newRow"></slot>
					<td v-for="(column, index) in columns" :key="index">
						<div v-if="column.readonly" :key="column.field">
							<slot :name="'__' + column.field" :field="column.field" :row="newRow" :index="index" :value="newRow[index]">
								<div v-html="newRow.row[index]"></div>
							</slot>
						</div>
						<div v-else :key="column.field">
							<slot :name="'__' + column.field" :field="column.field" :row="newRow" :index="index" :value="newRow[index]">
								<input class="w-100" :value="newRow[index]" @change="change({ field: column.field, row: newRow, index, value: $event })"/>
							</slot>
						</div>
					</td>
					<td><mdb-btn @click="add" color="success" size="sm" rounded>Add</mdb-btn></td>
				</tr>
			</template>
			<template v-slot:post-table>
				<slot name="post-table"></slot>
			</template>
		</data-table>
	</mdb-col>
</template>

<script>
import { mdbBtn, mdbSelect } from '@/components/mdbvue'
import { mapState } from 'vuex'
import DataTable from '@/components/common/Datatable'

export default {
	name: 'EditTable',
	components: { mdbBtn, mdbSelect, DataTable },
	props: {
		col: String | Object,
		columns: {
			type: Array,
			required: true
		},
		data: {
			type: Array,
			required: true
		},
		currentPage: {
			type: Number,
			default: 0
		},
		pagination: {
			type: Boolean,
			default: true
		},
		search: {
			type: Boolean,
			default: true
		},
		newRowFlag: {
			type: String,
			default: 'new'
		},
		headerColor: {
			type: String
		},
		headerWhite: {
			type: Boolean,
			default: false
		}
	},
	emits: [ 'update', 'delete', 'page' ],
	data () {
		return {
			newRowRow: { [this.newRowFlag]: true }
		}
	},
	computed: {
		rows () {
			return this.data // .concat({ id: null })
		},
		colBind () {
			if (!this.col) {
				return {}
			} else if (this.col.constructor === Object) {
				return this.col
			} else {
				return { col: this.col }
			}
		},
		newRow () {
			const row = this.columns.map(c => this.newRowRow[c.field] || null)
			row.row = this.newRowRow
			row.key = null
			return row
		},
		pages () {
			return this.$attrs.onPages
		},
		on () {
			const sync = this.$attrs.onSync
			const pages = this.$attrs.onPages
			return Object.assign({}, sync && { sync }, pages && { pages })
		},
		...mapState(['locale'])
	},
	watch: {
		rows () {
			this.newRowRow = { [this.newRowFlag]: true }
		}
	},
	methods: {
		change (evt) {
			console.debug(evt)
			let { field, row, index, value } = evt
			if (value && value.target) {
				value = value.target.value
			}
			if (value !== null && value !== '' && value !== row.row[field]) {
				Object.assign(row.row, { [field]: value })
				if (this.isNew(row)) {
					row[index] = value
				} else {
					this.$emit('update', row.row)
				}
			}
		},
		isNew (row) {
			const rowRow = row.row
			return !!(rowRow && rowRow[this.newRowFlag])
		},
		remove (row) {
			if (!this.isNew(row) && confirm(this.$t('common.confirm-removal', this.locale))) {
				this.$emit('delete', row.row)
			}
		},
		add () {
			this.$emit('update', this.newRow.row)
		},
		changePage (page) {
			this.$emit('page', page)
		}
	}
}
</script>

<style scoped>
>>> .md-form {
	margin-top: 0;
	margin-bottom: 0;
}
>>> input.select-dropdown {
	margin-bottom: 0;
}
</style>
